"use strict";

exports.__esModule = true;
exports.default = void 0;
var _utils = require("../utils");
var _checkbox = require("../mixins/checkbox");
var _use = (0, _utils.use)('radio'),
  sfc = _use[0],
  bem = _use[1];
var _default2 = sfc({
  mixins: [(0, _checkbox.CheckboxMixin)('z-radio-group', bem)],
  props: {
    onClickItemHook: {
      type: Function,
      default: function _default(item, done) {
        return done();
      }
    }
  },
  computed: {
    currentValue: {
      get: function get() {
        return this.parent ? this.parent.value : this.value;
      },
      set: function set(val) {
        (this.parent || this).$emit('input', val);
      }
    },
    checked: function checked() {
      return this.currentValue === this.name;
    }
  },
  methods: {
    onClickIcon: function onClickIcon(event) {
      var _this = this;
      this.onClickItemHook({
        prevValue: this.currentValue,
        prevSelected: this.currentValue === this.name
      }, function () {
        if (!_this.isDisabled) {
          _this.currentValue = _this.name;
          _this.$emit('click', event);
        }
      });
    },
    onClickLabel: function onClickLabel(event) {
      var _this2 = this;
      this.onClickItemHook({
        prevValue: this.currentValue,
        prevSelected: this.currentValue === this.name
      }, function () {
        if (!_this2.isDisabled && !_this2.labelDisabled) {
          _this2.currentValue = _this2.name;
          _this2.$emit('click', event);
        }
      });
    }
  }
});
exports.default = _default2;